export default __webpack_public_path__ + "static/1155-5ba81952e0c18a51a73dd2ebbe183148.gif";